/**
 * TRON mainnet base58 addresses: 34 chars, start with T.
 * Avoids `tronweb` in the bundle (CRA/webpack breaks on TronWebProto in ESM).
 */
const TRON_MAINNET_ADDRESS = /^T[1-9A-HJ-NP-Za-km-z]{33}$/

export const isValidTronAddress = (address: string): boolean => {
  if (!address || typeof address !== 'string') return false
  return TRON_MAINNET_ADDRESS.test(address.trim())
}
